import React from 'react'

const PrintMaterials = () => {
  return (
    <>
      <div className='pdf-container'>
        <p>Avatar Flyer</p>
        <object class="pdf-object" data="https://cdn.avatarnutrition.com/print-materials/avatar flyer 1.pdf" type="application/pdf">This browser does not support the object tag.</object>
      </div>
      <div className='pdf-container'>
        <p>Introduction to Avatar</p>
        <object class="pdf-object" data="https://cdn.avatarnutrition.com/print-materials/Introduction to Avatar .pdf" type="application/pdf">This browser does not support the object tag.</object>
      </div>
    </>
  )
}

export default PrintMaterials 